import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import './Config/disableActions';
import App from './App';

// Asegúrate de que el elemento con id 'app' esté presente en el HTML
const rootElement = document.getElementById('app');
if (!rootElement) {
  throw new Error('El contenedor de React no se encontró en el HTML.');
}

createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
